import { httpClient } from './http-client';
import type { ApiResponse } from './api.types';

export interface FamiliaDto {
  id: string;
  empresaId: string;
  codigo: string;
  nombre: string;
  esVisible: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface FamiliaInputDto {
  empresaId: string;
  codigo: string;
  nombre: string;
  esVisible?: boolean;
}

export const familiasService = {
  getAll: (empresaId: string): Promise<ApiResponse<FamiliaDto[]>> =>
    httpClient.get('/familias', { empresaId }),

  getById: (id: string): Promise<ApiResponse<FamiliaDto>> =>
    httpClient.get(`/familias/${id}`),

  create: (data: FamiliaInputDto): Promise<ApiResponse<FamiliaDto>> =>
    httpClient.post('/familias', data),

  update: (id: string, data: FamiliaInputDto): Promise<ApiResponse<FamiliaDto>> =>
    httpClient.put(`/familias/${id}`, data),

  delete: (id: string): Promise<ApiResponse<void>> =>
    httpClient.delete(`/familias/${id}`),
};
